/* RESPONSIBLE TEAM: team-proactive-support */
import EditTourController from 'embercom/controllers/apps/app/outbound/tour/edit';
export default EditTourController;
